import { useDataFormStore } from "@/stores/form";
import { NEWEST_BACKEND } from "@/remotes";
import { ref } from "vue";
import { getSpecialClientIntervals, getSpecialClientDeliveryIntervals, FALLBACK_INTERVAL } from "@/utils/timeIntervals";

// Необходимо указать после добавления необходимых параметров
let cargoTypes = {
    'Стандарт' : 1,
    'Цилиндры' : 2,
    'Шины' : 3,
}

function getKeyByValue(array, keyToMatch, valueToMatch) {
    const foundElement = array.find(obj => obj[keyToMatch] === valueToMatch);
    if (foundElement) {
      return array.indexOf(foundElement);
    }
    return -1;
}

export function getPackageKey(valueToMatch) {
    const dataForm = useDataFormStore();

    let array = dataForm.packagesTabs;
    let keyToMatch = 'name';

    return getKeyByValue(array, keyToMatch, valueToMatch)
}

export function getOtherKey(valueToMatch) {
  const dataForm = useDataFormStore();

  let array = dataForm.cargoOtherTabs;
  let keyToMatch = 'name';

  return getKeyByValue(array, keyToMatch, valueToMatch)
}

export function getSlidersTabKey(valueToMatch) {
  const dataForm = useDataFormStore();

  let array = dataForm.cargoInformationSlidersTabs;
  let keyToMatch = 'name';

    return getKeyByValue(array, keyToMatch, valueToMatch)
}

export function getCargoTabKey(valueToMatch) {
    const dataForm = useDataFormStore();

    let array = dataForm.cargoSpaceTabs;
    let keyToMatch = 'name';

    return getKeyByValue(array, keyToMatch, valueToMatch)
}

export function tabRemove(targetName, action) {

    const dataForm = useDataFormStore();

    if ((dataForm.cargoSpaceTabs.length == 1) || action != 'remove') return;

    const tabs = dataForm.cargoSpaceTabs
    const packageTabs = dataForm.packagesTabs;
    const sliderTabs = dataForm.cargoInformationSlidersTabs;

    let activeName = dataForm.cargoSpaceData;

    // Сдвиг табов
    if (activeName === targetName) {
    tabs.forEach((tab, index) => {
        if (tab.name === targetName) {
        const nextTab = tabs[index + 1] || tabs[index - 1]
        if (nextTab) activeName = nextTab.name
        }
    })
    }
    
    dataForm.cargoSpaceData = activeName
    dataForm.cargoSpaceTabs = tabs.filter((tab) => tab.name !== targetName)
    dataForm.packagesTabs   = packageTabs.filter((tab) => tab.name !== targetName)
    dataForm.cargoInformationSlidersTabs = sliderTabs.filter((tab) => tab.name !== targetName)

    // Перестройка названия табов
    let tab_count = 1;
    dataForm.cargoSpaceTabs.forEach((tab) => {
        tab.title = tab_count+' место';
        tab.counter = tab_count - 1;
        tab_count++;
    })
}

export function tabAdd() {
    const dataForm = useDataFormStore();

    let tabCount = dataForm.cargoSpaceTabs.length+1;
      const newTabName = `${++dataForm.tabIndex}`
      dataForm.packagesTabs.push({
        name: newTabName,
        typeOfPackagings: ref([]),
        additionalPackagingGroup: [],
        additionalPackagingGroupIds: [],
      })
      dataForm.cargoInformationSlidersTabs.push({
        name: newTabName,
        cargoVolumeSlider: 1,
        cargoWeightSlider: (dataForm.consignee?.cityTo).includes("(Москва)") ? 50 : 1,
      })
      dataForm.cargoOtherTabs.push({
        name: newTabName,
        warmPlace: false,
      })
      dataForm.cargoSpaceTabs.push({
        title: tabCount+' место',
        name: newTabName,
        cargoWeight: (dataForm.consignee?.cityTo).includes("(Москва)") ? 50 : 1,
        height: 10,
        length: 20,
        width: 20,
        diameter: 20,
        cargoVolume: 0.004,
        typeOfCargo: "Стандарт",
        typeOfPackaging: "",
        additionalPackaging: true,
        returnOfDocuments: false,
        cashOnDelivery: false,
        cashOnDeliverySum: null,
        typePowerOfAttorney: "",
        dataForTheDriver: false,
        sendTo: "",
        cargoRedemption: false,
        whoPaysTheRansom: "",
        cargoRedemptionSum: '',
        cargoCost: 3000,
        natureOfCargo: "",
        errorNatureOfCargo: false,
        counter: dataForm.cargoSpaceTabs.length,
        warmPlace: false,
      })
      dataForm.cargoSpaceData = newTabName
}

// Подсоеденен к watch
export async function tabRefreshPackages(index = undefined, tabID = -1) {
    const dataForm = useDataFormStore();

    let selectedTab = (tabID == -1) ? getPackageKey(dataForm.cargoSpaceData) : tabID;
    
    let selectedCargoTab = getCargoTabKey(dataForm.cargoSpaceData)

    let tab = dataForm.cargoSpaceTabs[selectedCargoTab]
    let tabPackages = dataForm.packagesTabs[selectedTab]
    
    if(tab.natureOfCargo == [] || !tab.natureOfCargo) return;
    if(!tab.natureOfCargo.id) return;

    if(tab.natureOfCargo.id == -1) {
      dataForm.packagesTabs[selectedTab].typeOfPackagings.value = [];
      return;
    }

    if( (dataForm.other.cargoCost == '') ||
        (tab.cargoWeight == '') ||
        (tab.width == '') ||
        (tab.length == '') ||
        (tab.height == '') ||
        (tab.diameter == '')
    ) return;

    if( (dataForm.other.cargoCost == 0) ||
        (tab.cargoWeight == 0) ||
        (tab.width == 0) ||
        (tab.length == 0) ||
        (tab.height == 0) ||
        (tab.diameter == 0)
    ) return;

    if(index) {
      if(tabPackages.additionalPackagingGroupIds.includes(index)) {
        var indexArr = tabPackages.additionalPackagingGroupIds.indexOf(index);
        if (indexArr !== -1) {
          tabPackages.additionalPackagingGroupIds.splice(indexArr, 1);
        }
      } else {
        tabPackages.additionalPackagingGroupIds.push(index);
      }
    } else {
      dataForm.packagesTabs[selectedTab].additionalPackagingGroupIds = [];
      dataForm.packagesTabs[selectedTab].additionalPackagingGroup = [];
    }
    

    let param = new URLSearchParams();
    param.append('CargoNaturesId', tab.natureOfCargo.id);
    param.append('CargoType', cargoTypes[tab.typeOfCargo]);
    param.append('DeclaredValue', dataForm.other.cargoCost);
    param.append('Weight', tab.cargoWeight);

    if(tabPackages.additionalPackagingGroupIds) {
      tabPackages.additionalPackagingGroupIds.forEach(element => {
        param.append('SelectedPackaging', element);
      });
    }

    switch (cargoTypes[tab.typeOfCargo]) {
      case 1:
        param.append('Length', Math.round(tab.length));
        param.append('Width', Math.round(tab.width));
        param.append('Height', Math.round(tab.height));
        break;
      case 2:
        param.append('Height', Math.round(tab.height));
        param.append('Diameter', Math.round(tab.diameter));
        break;
    }

    let config = {
      headers: {
        'Content-Type': 'application/json',
      },
      params: param,
    }

    // Запрос на упаковки
    try {
      const { data } = await NEWEST_BACKEND.get(`/public/available-packaging`, config);
      dataForm.packagesTabs[selectedTab].typeOfPackagings.value = data.filter((el) => !el.title.includes('УниПАК'));

      // Собираем массив выбранных посылок
      let selectedPackages = [];
      let selectedPackagesIds = [];


      data.forEach(element => {
        // if(element.isRequired == true && requiredNeeded) {
        //   if(!tabPackages.additionalPackagingGroup.includes(element.title)) {
        //     selectedPackages.unshift(element.title);
        //     selectedPackagesIds.push(element.id);
        //   }
        // }
        if(tabPackages.additionalPackagingGroup.includes(element.title)) {
          selectedPackages.push(element.title);
          selectedPackagesIds.push(element.id);
        }
      });
      
      dataForm.packagesTabs[selectedTab].additionalPackagingGroupIds = selectedPackagesIds;
      dataForm.packagesTabs[selectedTab].additionalPackagingGroup = selectedPackages;

      // dataForm.cargoOtherTabs[getOtherKey(tab.name)].warmPlace = selectedPackages.includes('Термобокс');

    } catch (e) {
      console.log(e);
    }
}

// Подсоеденен к watch
export async function tabRefreshTimePickup(type = false) {

  const dataForm = useDataFormStore();

  if((dataForm.consignee.cityTo == '') || (dataForm.sender.cityFrom == '')) return;
  
  // Только если загружаем временные промежутки от города отправки,
  // при отстуствии даты завершаем процесс обновления списка
  if(!type) if(dataForm.applicationCargoPickup.pickupDate == '') return;
  
  // Подготавливаем параметры
  let param = new URLSearchParams();
  let date;

  let city = (type) ? dataForm.cityDataTo.value.filter(e => e.title == dataForm.consignee.cityTo)[0]["id"] : dataForm.cityDataFrom.value.filter(e => e.title == dataForm.sender.cityFrom)[0]["id"]
  param.append('cityId', city);

  // Только если загружаем временные промежутки от города отправки,
  // указываем доп. данные
  if(!type) {
    date = new Date(dataForm.applicationCargoPickup.pickupDate)
    date = date.getFullYear() + '-' + ('0' + (date.getMonth()+1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2)
    
    param.append('date', date);

    dataForm.cargoSpaceTabs.forEach(tab => {
      param.append('CargoType', cargoTypes[tab.typeOfCargo]);
      param.append('Weight', tab.cargoWeight);
    
      switch (cargoTypes[tab.typeOfCargo]) {
        case 1:
          param.append('Length', Math.round(tab.length));
          param.append('Width', Math.round(tab.width));
          param.append('Height', Math.round(tab.height));
          break;
        case 2:
          param.append('Height', Math.round(tab.height));
          param.append('Diameter', Math.round(tab.diameter));
          break;
      }
    });
  }
    
  

  let config = {
    headers: {
      'Content-Type': 'application/json',
    },
    params: param,
  }

  // Запрос на упаковки
  try {
    if (type) {

      const { data } = await NEWEST_BACKEND.get(`/public/available-delivery-time`, config);

      dataForm.applicationCargoPickupTime.cargoTimePickupRangeDelivery.value = data;

      dataForm.applicationCargoPickupTime.cargoTimePickupRangeDelivery.value = (dataForm.applicationCargoPickupTime.cargoTimePickupRangeDelivery.value[0])
        ? (dataForm.isSpecialClient) ? getSpecialClientDeliveryIntervals() : dataForm.applicationCargoPickupTime.cargoTimePickupRangeDelivery.value
        : FALLBACK_INTERVAL;

      dataForm.applicationCargoPickupTime.cargoTimePickupDelivery = (dataForm.consignee?.cityTo.includes('(Москва)')) ? dataForm.applicationCargoPickupTime.cargoTimePickupRangeDelivery.value[0] : [];

    } else {

      const { data } = await NEWEST_BACKEND.get(`/public/available-pick-up-time`, config);

      dataForm.applicationCargoPickupTime.cargoTimePickupRange.value = data.filter(e => {
        return e.date == date
      });

      dataForm.applicationCargoPickupTime.cargoTimePickupRange.value = (dataForm.applicationCargoPickupTime.cargoTimePickupRange.value[0])
        ? (dataForm.isSpecialClient) ? getSpecialClientIntervals() : dataForm.applicationCargoPickupTime.cargoTimePickupRange.value[0].pickUpTimePeriods
        : FALLBACK_INTERVAL;

      dataForm.applicationCargoPickupTime.cargoTimePickup = [];
    }

  } catch (e) {
    console.log(e);
  }
}

export async function tabRefreshTimePickupDelivery() {
  tabRefreshTimePickup('delivery');
}